import { CommonInviteModal } from '.';

interface InviteTaxProClientModalProps {
  show: boolean;
  onHide: () => void;
}

/** Tax Pro Modal to invite Client by email. */
export const InviteTaxProClientModal = (
  props: InviteTaxProClientModalProps,
) => {
  return (
    <CommonInviteModal
      {...props}
      titleText="Add case to begin"
      bodyText={<p>Add taxpayer details to begin working on a new case.</p>}
      loading={false}
    />
  );
};
